import { ActionTypes as actions } from '../actions';

const initialState = {
  auth: null,
  user: null,
  users: null,
  practices: null,
  roles: null,
  notificationPreferences: null,
  diplayedTolstoyCount: null,
}

export default function UserReducer(state=initialState, action) {

  switch(action.type) {
    case actions.USER_AUTH_UPDATE:
      state = { ...state, auth: action.payload };
      break;
    case actions.USER_UPDATE_INFO:
      state = { ...state, user: action.payload };
      break;
    case actions.USER_ADD_USER:
      var updatedUsers = state.users ? Object.assign({}, state.users) : {};
      var userToAdd = action.payload;
      updatedUsers[userToAdd._id] = userToAdd;
      state = { ...state, users: updatedUsers };
      break;
    case actions.USER_ADD_ROLE:
      var updatedRoles = state.roles ? Object.assign({}, state.roles) : {};
      const roleToAdd = action.payload;
      updatedRoles[roleToAdd.practice_id] = roleToAdd;
      state = { ...state, roles: updatedRoles };
      break;
    case actions.USER_UPDATE_ROLES:
      state = { ...state, roles: action.payload };
      break;
    case actions.USER_REMOVE_ROLE:
      var rolesUpdated = state.roles ? Object.assign({}, state.roles) : {};
      const roleToRemove = action.payload;
      if (rolesUpdated[roleToRemove.practice_id]) {
        delete rolesUpdated[roleToRemove.practice_id];
      }
      state = { ...state, roles: rolesUpdated };
      break;
    case actions.USER_ADD_PRACTICE:
      var updatedPractices = state.practices ? Object.assign({}, state.practices) : {};
      const practiceToAdd = action.payload;
      updatedPractices[practiceToAdd._id] = practiceToAdd;
      state = { ...state, practices: updatedPractices };
      break;
    case actions.USER_NOTIFICATION_PREFERENCES_UPDATE:
      state = { ...state, notificationPreferences: action.payload };
      break;
    case actions.USER_DISPLAYED_TOLSTOY_COUNT_UPDATE:
      state = { ...state, diplayedTolstoyCount: action.payload };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
